import styled from 'styled-components'
import { CRIMSON_500, DARK_VIOLET, GRAYSCALE_500, NEUTRAL_100, VIOLET_600, WHITE, PALE_RIBBON } from '../../styles/colors'
import { INTER } from '../../styles/fonts'
import topUpIcon from '../../assets/icons/ActionButtonTopUp.svg'

// Cast to avoid ts(2883) portability error caused by @types/react version
// mismatch between packages/ui and other packages in the monorepo.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Container = (styled.div`
  background-color: ${PALE_RIBBON};
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid ${NEUTRAL_100};
  padding: 24px;
  gap: 12px;
  width: 100%;
  border-radius: 12px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Label = (styled.span`
  font-family: ${INTER.medium};
  font-size: 14px;
  color: ${GRAYSCALE_500};
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AmountContainer = (styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Amount = (styled.span`
  font-family: ${INTER.bold};
  font-size: 24px;
  color: ${DARK_VIOLET};
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const InsufficientText = (styled.span`
  font-family: ${INTER.regular};
  font-size: 14px;
  color: ${VIOLET_600};
  text-align: center;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const InsufficientAmount = (styled.span`
  font-family: ${INTER.bold};
  font-size: 14px;
  color: ${CRIMSON_500};
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TopUpButtonContainer = (styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  background-color: ${WHITE};
  border: 2px solid ${NEUTRAL_100};
  border-radius: 360px;
  padding: 10px 18px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TopUpButtonText = (styled.span`
  font-family: ${INTER.medium};
  font-size: 15px;
  color: ${VIOLET_600};
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ActionTopUpIcon = (styled.img.attrs({ src: topUpIcon })``) as any // eslint-disable-line @typescript-eslint/no-explicit-any
